import Cookies from "js-cookie";
import { get, isArray, isObjectLike, has } from "lodash";

export const login = (token: string) => {
  Cookies.set("auth_token", token);
};

export const removeAuth = () => {
  Cookies.remove("auth_token");
};

export const formatErrorObject = (
  error: any,
  path = "response.data"
): string => {
  const errorObj = path ? get(error, path) : error;
  let errorMessage = errorObj?.message;
  if (has(errorMessage, "message")) {
    errorMessage = errorMessage.message;
  }
  return isObjectLike(errorMessage) || isArray(errorMessage)
    ? JSON.stringify(errorMessage)
    : errorMessage;
};
